import React, { useEffect, Fragment, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { authTokenSelector, sessionSelector } from '../../selectors/auth.selector'
import { setLogout } from '../../actions'
import '../../styles/Layout.css'
import { Col, Container, Row } from 'react-bootstrap'
import HeaderNew from '../Header/Header-new'

export default function Layout({ children, sidebar, loadingSideBar }) {
  const sessionLogout = useSelector(sessionSelector)
  const history = useHistory()
  const dispatch = useDispatch()
  const [showSideNav, setShowSideNav] = useState(false)
  const authToken = useSelector(authTokenSelector)

    useEffect(() => {
    if (authToken === null) {
     history.push('/login')
    }
  }, [authToken])


  useEffect(() => {
    if (sessionLogout === true) {
      dispatch(setLogout(false))
      history.push('/auth')
    }
  }, [sessionLogout])

  return (
    <Fragment>
      <HeaderNew />
      <Container id='Layout'>
        <Row className='layout-render-section'>
          <Col> {children}</Col>
        </Row>
      </Container>
    </Fragment>
  )
}
